<template>
  <zip-package-requirement v-if="hasZipSpec" :spec="zipPackageSpec" :asset-type="assetType" />
</template>

<script>
import basicFormMixin from './basicFormMixin'
import ZipPackageRequirement from './ZipPackageRequirement.vue'
import { resolveZipPackageSpec, hasZipPackageSpec } from '../genericResourceZipPackageSpec'

export default {
  name: 'ZipCustomBasicForm',
  components: { ZipPackageRequirement },
  mixins: [basicFormMixin],
  props: {
    assetType: { type: String, default: '' },
  },
  computed: {
    zipPackageSpec() {
      return resolveZipPackageSpec(this.assetType)
    },
    hasZipSpec() {
      return hasZipPackageSpec(this.assetType)
    },
  },
}
</script>
